import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// React 19 hoists Helmet tags but does not adopt the static crawler tags.
// Hand metadata ownership to React once the application bundle is ready.
document.head.querySelectorAll('[data-rh="true"], title').forEach((tag) => tag.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
